import React from 'react'

const errorBoundaryInitialState = {
  hasError: false,
  error: null
}

const DefaultErrorFallback = props => {
  return JSON.stringify(props.error, ' ', 2)
}

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = errorBoundaryInitialState
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error: {
        message: error.message
      }
    }
  }

  static defaultProps = {
    fallback: DefaultErrorFallback
  }

  handleSubmitError = () => {
    this.setState(errorBoundaryInitialState)
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      const FallbackComponent = this.props.fallback

      return (
        <FallbackComponent
          submitError={this.handleSubmitError}
          error={this.state.error}
        />
      )
    }

    return this.props.children
  }
}
